module.exports = __webpack_public_path__ + "img/guess_left_nor.0c21e408.png";